import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from 'src/app/shared/components/login/login/login.component';
import { AuthGuardService } from 'src/app/shared/core/interceptors/auth-guard.service';
import { AccueilComponent } from 'src/app/user/components/accueil/accueil.component';
import { ForgotPasswordComponent } from 'src/app/shared/components/forgot-password/forgot-password.component';
import { RetrievePasswordComponent } from 'src/app/shared/components/retrieve-password/retrieve-password.component';
import { ChangerMotDePasseComponent } from 'src/app/shared/components/changer-mot-de-passe/changer-mot-de-passe.component';
import { CategoriesComponent } from 'src-adisco/categories/categories.component';
import { ProductDetailComponent } from 'src-adisco/product-detail/product-detail.component';
import { LogoutComponent } from 'src/app/shared/components/logout/logout.component';
import { ProductComparatorComponent } from 'src-adisco/product-comparator/product-comparator.component';
import { SuppliersComponent } from 'src-adisco/suppliers/suppliers.component';
import { DetailSupplierComponent } from 'src-adisco/suppliers/detail-supplier/detail-supplier.component';
import { MembersComponent } from 'src-adisco/members/members.component';
import { DetailMemberComponent } from 'src-adisco/members/detail-member/detail-member.component';
import { MemberFileComponent } from 'src-adisco/gestion/member-file/member-file.component';
import { CustomerProspectComponent } from 'src-adisco/gestion/customer-prospect/customer-prospect.component';
import { CreateEditProspectComponent } from 'src-adisco/gestion/customer-prospect/create-edit-prospect/create-edit-prospect.component';
import { MyCategoriesComponent } from 'src-adisco/gestion/my-categories/my-categories.component';
import { MyAccountComponent } from 'src-adisco/my-account/my-account.component';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { AdminUserGroupParameterComponent } from 'src/app/shared/components/admin-user-group-parameter/admin-user-group-parameter.component';
import { AuthGuardAdiscoMemberService } from 'src-adisco/services/authGuard-adisco-member.service';
import { ResourceFileRedirectComponent } from 'src/app/shared/components/resource-file-redirect/resource-file-redirect.component';

import { ExternalRedirectComponent } from 'src/app/shared/components/external-redirect/external-redirect.component';
import { FrameImportComponent } from 'src/app/shared/components/frame-import/frame-import.component';
import { FrameValidationComponent } from 'src/app/shared/components/frame-validation/frame-validation.component';
import { SimpleAuthGuardService } from 'src/app/shared/core/interceptors/simple-auth-guard.service copy';

// import { AuthGuardAdiscoSupplierService } from 'src-adisco/services/authGuard-adisco-supplier.service';

export const PATHS = {
    login: 'login',
    logout: 'logout',
    admin: 'admin',
    customID: ':id',
    //
    home: '',
    home_en: 'home',
    home_fr: 'accueil',
    home_es: 'inicio',
    home_de: 'startseite',
    //
    catalogues: 'catalogues',
    catalogues_en: 'catalog',
    catalogues_fr: 'catalogues',
    catalogues_es: 'catalogo',
    catalogues_de: 'katalog',
    //
    product: 'produit',
    product_en: 'product',
    product_fr: 'produit',
    product_es: 'producto',
    product_de: 'produkt',
    //
    machines: 'machines',
    machines_en: 'machines',
    machines_fr: 'machines',
    machines_es: 'maquinas',
    machines_de: 'maschinen',
    //
    consumables: 'consommables',
    consumables_en: 'consumables',
    consumables_fr: 'consommables',
    consumables_es: 'consumibles',
    consumables_de: 'verbrauchsmaterialen',
    //
    technologies: 'technologies',
    technologies_en: 'technologies',
    technologies_fr: 'technologies',
    technologies_es: 'tecnologias',
    technologies_de: 'technologien',
    //
    company: 'societe',
    company_en: 'company',
    company_fr: 'societe',
    company_es: 'empresa',
    company_de: 'geschaft',
    //
    news: 'actualites',
    news_en: 'news',
    news_fr: 'actualites',
    news_es: 'noticias',
    news_de: 'neuigkeiten',
    //
    contact: 'contact',
    contact_en: 'contact',
    contact_fr: 'contact',
    contact_es: 'contacto',
    contact_de: 'kontakt',
    //
    account: 'mon-compte',
    devis: 'devis',
    favorite: 'favoris',
    forgot: 'forgot-password',
    retrieve: 'retrievepassword/reset',
    //
    modifyPassword: 'changer-mot-de-passe',
    fournisseur: 'fournisseur',
    monEspace: 'espace',
    moncatalogues: 'catalogues',
    monEurochef: 'catalogues-eurochef',
    suppliers: 'fournisseurs',
    bibliotheque: 'biblo',
    gestion: 'gestion',
    gestion_article: 'articles',
    gestion_fournisseurs: 'fournisseurs',
    gestion_marques: 'marques',
    gestion_associe: 'associe',
    gestion_clients: 'clients',
    categorie: 'categorie',
    associates: 'associes',
    roles: 'roles',
    projectOverview: 'project-overview',
    projectDetail: 'project-detail',
    resourceFilesRedirect: 'resource-files-redirect',
    external_download: 'ironside-resources',
};

export const OGPATHS = {
    home: 'home',
    catalogues: 'catalogues',
    product: 'product',
    machines: 'machines',
    consumables: 'consumables',
    technologies: 'technologies',
    company: 'company',
    news: 'news',
    contact: 'contact',
    frames: 'trames',
    import: 'import',
    validation: 'validation',
};

const routes: Routes = [
    {
        path: `${PATHS.admin}/${PATHS.resourceFilesRedirect}/${PATHS.customID}`,
        component: ResourceFileRedirectComponent,
    },

    { path: PATHS.login, component: LoginComponent },
    { path: PATHS.logout, component: LogoutComponent },
    {
        path: `${PATHS.admin}/${PATHS.customID}`,
        component: DashboardComponent,
        canActivate: [AuthGuardService],
    },

    { path: PATHS.forgot, component: ForgotPasswordComponent },
    { path: PATHS.retrieve, component: RetrievePasswordComponent },
    { path: PATHS.modifyPassword, component: ChangerMotDePasseComponent },
    {
        path: PATHS.home,
        component: AccueilComponent,
        canActivate: [AuthGuardService],
    },

    {
        // I want to redirect to external url the token will be gotten from the local storage, how do i do this https://adisco-ao.geolane.fr/login?token=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6InByb2Z1c2lvbiIsImNvbnRhY3RJZCI6NTUyLCJpYXQiOjE3MzY3NjEzODksImV4cCI6MTczNjg0Nzc4OX0.PdO6N8ifkAPucUkjmWRIPSogLPXCys7S_W20Y-pDXk0
        path: 'devis',
        component: ExternalRedirectComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'catalogues',
        component: CategoriesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'catalogues/:id',
        component: CategoriesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: '/catalogues/rechercher',
        component: CategoriesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'catalogues/product-detail/:id',
        component: ProductDetailComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'product-comparator',
        component: ProductComparatorComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'suppliers',
        component: SuppliersComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'suppliers/detail-supplier/:id',
        component: DetailSupplierComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'catalogues/suppliers/:id',
        component: CategoriesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'members',
        component: MembersComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'members/detail-member/:id',
        component: DetailMemberComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'gestion/member-file',
        component: MemberFileComponent,
        canActivate: [AuthGuardService],
    },

    {
        path: 'gestion/customer-prospect',
        component: CustomerProspectComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'gestion/customer-prospect/create',
        component: CreateEditProspectComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'gestion/customer-prospect/edit/:id',
        component: CreateEditProspectComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'gestion/my-categories',
        component: MyCategoriesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'my-account',
        component: MyAccountComponent,
        canActivate: [AuthGuardService],
    },

    // Admins
    {
        path: `${OGPATHS.import}`,
        component: FrameImportComponent,
        canActivate: [SimpleAuthGuardService],
    },
    {
        path: `${OGPATHS.validation}`,
        component: FrameValidationComponent,
        canActivate: [SimpleAuthGuardService],
    },
    {
        path: PATHS.roles,
        component: AdminUserGroupParameterComponent,
    },
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
